import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import '../../TargetReport/TableContent/index.css';
import './operations.css';
import { Height } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { monthStringToNumber } from '../../../../utils/monthStringToNumber'
import { Tooltip } from '@material-ui/core';

function TableContent({
  tableData,
  headerData,
  totalTableData,
  mediaCrescimento,
  updateMeta,
  setUpdateMetaData,
  setUpdateMeta,
  projecaoTableData,
  projecaoTotalTableData,
}) {
  const [model, setModel] = useState();
  const [header, setHeader] = useState({
    mes1Nome: '',
    mes2Nome: '',
    mes3Nome: '',
    mesMetaNome: '',
    dataHora: '',
    mediaCrescimento: '',
  });
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const toCurrency = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <span>{e ? formatter.format(e) : '0,00'}</span>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (headerData) {
      setHeader({
        mesReferencia: headerData.mesReferencia,
        mesPrincipal: headerData.mesPrincipal,
      });
    }
  }, [headerData]);

  const handleDate = (date) => {
    if(date) {
      const dateSplit = date.split(' ');
      const month = monthStringToNumber(dateSplit[0].toUpperCase());
      const year = dateSplit[1]
      return '1-' + month + '-' + year;
    } else {
      return ''
    }
  }

  const bodyTableProd = tableData?.map(function (item, index) {
    let backColor = 'white';
    if (index % 2) {
      backColor = '#EEEEEE';
    }
    return (
      <>
        <TableRow style={{ backgroundColor: backColor }}>
          <Tooltip placement="top" title={
            item.analistas ? 
            <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
          >
            <TableCell align="left">
              <Link to={'/app/relatorios/mensal/' + item.ancoraId + '/' + handleDate(headerData?.mesPrincipal)} style={{ textDecoration: 'none', color: '#232d64' }}>
                {item.ancora}
              </Link>
            </TableCell>
          </Tooltip>
          <TableCell align="right">{toCurrency(item.antecipacaoMesReferencia)}</TableCell>
          <TableCell align="right">{toCurrency(item.antecipacaoMesPrincipal)}</TableCell>
          <TableCell
            style={{ color: item.antecipacaoDiferenca < 0 ? 'red' : 'blue' }}
            align="right"
          >
            {toCurrency(item.antecipacaoDiferenca)}
          </TableCell>
          <TableCell align="right">{toCurrency(item.receitaEmpresaMesReferencia)}</TableCell>
          <TableCell align="right">{toCurrency(item.receitaEmpresaMesPrincipal)}</TableCell>
          <TableCell
            style={{ color: item.receitaEmpresaDiferenca < 0 ? 'red' : 'blue' }}
            align="right"
          >
            {toCurrency(item.receitaEmpresaDiferenca)}
          </TableCell>
          <TableCell align="right">{toCurrency(item.receitaCapittaleMesReferencia)}</TableCell>
          <TableCell align="right">{toCurrency(item.receitaCapittaleMesPrincipal)}</TableCell>
          <TableCell
            style={{ color: item.receitaCapittaleDiferenca < 0 ? 'red' : 'blue' }}
            align="right"
          >
            {toCurrency(item.receitaCapittaleDiferenca)}
          </TableCell>
          <TableCell align="right">
            {item.percentualRecVolCapittaleMesReferencia?.toFixed(2).replace('.', ',')} %
          </TableCell>
          <TableCell align="right">
            {item.percentualRecVolCapittaleMesPrincipal?.toFixed(2).replace('.', ',')} %
          </TableCell>
          <TableCell
            style={{ color: item.percentualRecVolCapittaleDiferenca < 0 ? 'red' : 'blue' }}
            align="right"
          >
            {item.percentualRecVolCapittaleDiferenca?.toFixed(2).replace('.', ',')} %
          </TableCell>
          <TableCell align="center">{item.quantidadeFornecedoresDiferentesMesReferencia}</TableCell>
          <TableCell align="center">{item.quantidadeOperacoesRealizadoMesReferencia}</TableCell>
          <TableCell align="center">{item.quantidadeQualificadosRealizadoMesReferencia}</TableCell>
          <TableCell align="center">{item.quantidadeNaoQualificadosRealizadoMesReferencia}</TableCell>

          <TableCell align="center">{item.quantidadeFornecedoresDiferentesMesPrincipal}</TableCell>
          <TableCell align="center">{item.quantidadeOperacoesRealizadoMesPrincipal}</TableCell>
          <TableCell align="center">{item.quantidadeQualificadosRealizadoMesPrincipal}</TableCell>
          <TableCell align="center">{item.quantidadeNaoQualificadosRealizadoMesPrincipal}</TableCell>
        </TableRow>
      </>
    );
  });

  const bodyTableProdTotal = (
    <>
      <TableRow style={{ background: '#c4c4c4' }}>
        <TableCell rowSpan={2} align="left" style={{ color: 'black', fontWeight: 'bold' }}>
          Total
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>{toCurrency(totalTableData?.antecipacaoMesReferencia)}</TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>{toCurrency(totalTableData?.antecipacaoMesPrincipal)}</TableCell>
        <TableCell
          style={{ color: totalTableData?.antecipacaoDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(totalTableData?.antecipacaoDiferenca)}
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {toCurrency(totalTableData?.receitaEmpresaMesReferencia)}
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {toCurrency(totalTableData?.receitaEmpresaMesPrincipal)}
        </TableCell>
        <TableCell
          style={{ color: totalTableData?.receitaEmpresaDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(totalTableData?.receitaEmpresaDiferenca)}
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {toCurrency(totalTableData?.receitaCapittaleMesReferencia)}
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {toCurrency(totalTableData?.receitaCapittaleMesPrincipal)}
        </TableCell>
        <TableCell
          style={{ color: totalTableData?.receitaCapittaleDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(totalTableData?.receitaCapittaleDiferenca)}
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.percentualRecVolCapittaleMesReferencia?.toFixed(2).replace('.', ',')} %
        </TableCell>
        <TableCell align="right" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.percentualRecVolCapittaleMesPrincipal?.toFixed(2).replace('.', ',')} %
        </TableCell>
        <TableCell
          align="right"
          style={{ color: totalTableData?.percentualRecVolCapittaleDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
        >
          {totalTableData?.percentualRecVolCapittaleDiferenca?.toFixed(2).replace('.', ',')} %
        </TableCell>
        
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeFornecedoresDiferentesMesReferencia}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeOperacoesRealizadoMesReferencia}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeQualificadosRealizadoMesReferencia}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeNaoQualificadosRealizadoMesReferencia}
        </TableCell>

        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeFornecedoresDiferentesMesPrincipal}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeOperacoesRealizadoMesPrincipal}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeQualificadosRealizadoMesPrincipal}
        </TableCell>
        <TableCell align="center" style={{ color: 'black', fontWeight: 'bold' }}>
          {totalTableData?.quantidadeNaoQualificadosRealizadoMesPrincipal}
        </TableCell>
      </TableRow>
    </>
  );

  const bodyTableProjecao = projecaoTableData?.map(function (item, index) {
    let backColor = 'white';
    if (index % 2) {
      backColor = '#EEEEEE';
    }
    return (
      <>
        <TableRow style={{ backgroundColor: backColor }}>
          <Tooltip placement="top" title={
            item.analistas ? 
            <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> : ''}
          >
            <TableCell align="left">
              <Link to={'/app/relatorios/mensal/' + item.ancoraId + '/' + handleDate(headerData?.mesPrincipal)} style={{ textDecoration: 'none', color: '#232d64' }}>
                {item.ancora}
              </Link>
            </TableCell>
          </Tooltip>
          <TableCell align="right">{item.desagioMesReferencia?.toFixed(2)} %</TableCell>
          <TableCell align="right">{item.desagioMesPrincipal?.toFixed(2)} %</TableCell>
          <TableCell align="right">{item.taxaMesReferencia?.toFixed(2)} %</TableCell>
          <TableCell align="right">{item.taxaMesPrincipal?.toFixed(2)} %</TableCell>
          <TableCell style={{ color: item.antecipacao < 0 ? 'red' : 'blue' }} align="right">
            {toCurrency(item.antecipacao)}
          </TableCell>
          <TableCell style={{ color: item.receitaEmpresa < 0 ? 'red' : 'blue' }} align="right">
            {toCurrency(item.receitaEmpresa)}
          </TableCell>
          <TableCell style={{ color: item.receitaCapittale < 0 ? 'red' : 'blue' }} align="right">
            {toCurrency(item.receitaCapittale)}
          </TableCell>
        </TableRow>
      </>
    );
  });
  const bodyTableProjecaoTotal = (
    <>
      <TableRow style={{ background: '#c4c4c4' }}>
      <TableCell align="left" style={{ background: '#c4c4c4', color: 'black', fontWeight: 'bold' }}>
          Saldo Atual
        </TableCell>

        <TableCell
          style={{ color: projecaoTotalTableData?.desagioMesReferencia < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {projecaoTotalTableData?.desagioMesReferencia.toFixed(2)} %
        </TableCell>

        <TableCell
          style={{ color: projecaoTotalTableData?.desagioMesPrincipal < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {projecaoTotalTableData?.desagioMesPrincipal.toFixed(2)} %
        </TableCell>

        <TableCell
          style={{ color: projecaoTotalTableData?.taxaMesReferencia < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {projecaoTotalTableData?.taxaMesReferencia.toFixed(2)} %
        </TableCell>

        <TableCell
          style={{ color: projecaoTotalTableData?.taxaMesPrincipal < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {projecaoTotalTableData?.taxaMesPrincipal.toFixed(2)} %
        </TableCell>

        <TableCell
          style={{ color: projecaoTotalTableData?.antecipacaoAtingido < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.antecipacaoAtingido)}
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.receitaEmpresaAtingido < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.receitaEmpresaAtingido)}
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.receitaCapittaleAtingido < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.receitaCapittaleAtingido)}
          </TableCell>
          </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
      <TableCell colSpan={5} align="left" style={{ color: 'black', fontWeight: 'bold', borderLeft: 'none' }}>
          Fechamento Projetado
        </TableCell>
      <TableCell
          style={{
            color: projecaoTotalTableData?.antecipacaoObjetivo < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.antecipacaoObjetivo)}
        </TableCell>
        <TableCell
          style={{
            color: projecaoTotalTableData?.receitaEmpresaObjetivo < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.receitaEmpresaObjetivo)}
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.receitaCapittaleObjetivo < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.receitaCapittaleObjetivo)}
        </TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
      <TableCell colSpan={5} align="left" style={{ color: 'black', fontWeight: 'bold', borderLeft: 'none' }}>
          Meta
        </TableCell>
      <TableCell
          style={{
            color: projecaoTotalTableData?.capittaleMetaAntecipacao < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.capittaleMetaAntecipacao)}
        </TableCell>
        <TableCell
          style={{
            color: projecaoTotalTableData?.capittaleMetaReceitaEmpresa < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.capittaleMetaReceitaEmpresa)}
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.capittaleMetaReceitaCapittale < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {
            // toCurrency(projecaoTotalTableData?.capittaleMetaReceitaCapittale)
          }
        </TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
      <TableCell colSpan={5} align="left" style={{ color: 'black', fontWeight: 'bold', borderLeft: 'none' }}>
          Diferença (Fechamento Projetado - Meta)
        </TableCell>
      <TableCell
          style={{
            color: projecaoTotalTableData?.antecipacaoDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.antecipacaoDiferenca)}
        </TableCell>
        <TableCell
          style={{
            color: projecaoTotalTableData?.receitaEmpresaDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {toCurrency(projecaoTotalTableData?.receitaEmpresaDiferenca)}
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.receitaCapittaleDiferenca < 0 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >
          {
            // toCurrency(projecaoTotalTableData?.receitaCapittaleDiferenca)
          }
        </TableCell>
      </TableRow>
      <TableRow style={{ background: '#c4c4c4' }}>
      <TableCell colSpan={5} align="left" style={{ color: 'black', fontWeight: 'bold', borderLeft: 'none' }}>
          % Atingimento Projetado (Fechamento Projetado / Meta)
        </TableCell>
      <TableCell
          style={{
            color: projecaoTotalTableData?.fechamentoProjetadoAntecipacao < 100 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {projecaoTotalTableData?.fechamentoProjetadoAntecipacao?.toFixed(2)} %
        </TableCell>
        <TableCell
          style={{
            color: projecaoTotalTableData?.fechamentoProjetadoReceitaEmpresa < 100 ? 'red' : 'blue', fontWeight: 'bold',
          }}
          align="right"
        >
          {projecaoTotalTableData?.fechamentoProjetadoReceitaEmpresa?.toFixed(2)} %
        </TableCell>
        <TableCell
          style={{ color: projecaoTotalTableData?.fechamentoProjetadoReceitaCapittale < 100 ? 'red' : 'blue', fontWeight: 'bold' }}
          align="right"
        >{projecaoTotalTableData?.fechamentoProjetadoReceitaCapittale?.toFixed(2)} %
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      <div
        className="report-tables"
        style={{
          margin: '20px 50px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
          flexWrap: 'wrap',
          display: headerData ? 'flex' : 'none',
        }}
      >
        <Table
          style={{
            margin: '15px',
            backgroundColor: 'white',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" rowSpan={2}>
                Rede
              </TableCell>
              <TableCell
                style={{ color: 'white', fontWeight: 'bold' }}
                align="center"
                rowSpan={1}
                colSpan={3}
              >
                Volume de Antecipação
              </TableCell>
              <TableCell
                style={{ color: 'white', fontWeight: 'bold' }}
                align="center"
                rowSpan={1}
                colSpan={3}
              >
                Receita da Rede
              </TableCell>
              <TableCell
                style={{ color: 'white', fontWeight: 'bold' }}
                align="center"
                rowSpan={1}
                colSpan={3}
              >
                Receita Capittale
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" colSpan={3}>
                Percentual Rec/Vol Capittale
              </TableCell>
              <TableCell
                style={{ color: 'white', fontWeight: 'bold', padding: '4px' }}
                align="center"
                rowSpan={1}
                colSpan={8}
              >
                <div style={{ display: 'block' }}>
                  <p style={{ width: '100%', margin: '0px' }}>Operações</p>
                  <div style={{ display: 'flex' }}>
                    <p style={{ width: '50%', margin: '0px' }}>{header.mesReferencia}</p>
                    <p style={{ width: '50%', margin: '0px' }}>{header.mesPrincipal}</p>
                  </div>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesReferencia}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesPrincipal}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Resultado
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesReferencia}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesPrincipal}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Resultado
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesReferencia}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesPrincipal}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Resultado
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesReferencia}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                {header.mesPrincipal}
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Resultado
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Forn
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Qtd
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Qualif
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                N.Qualif
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Forn
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Qtd
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Qualif
              </TableCell>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                N.Qualif
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          <TableRow>
          </TableRow>
            {bodyTableProd}
            <TableRow>
          </TableRow>
            {bodyTableProdTotal}
          </TableBody>
        </Table>
        <div>
          <Table
            style={{
              margin: '15px',
              backgroundColor: 'white',
              boxShadow:
                '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
            }}
          >
            <TableHead style={{ backgroundColor: '#232C63' }}>
              <TableRow>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  rowSpan={2}
                >
                  Rede
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  rowSpan={1}
                  colSpan={2}
                >
                  Deságio
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  rowSpan={1}
                  colSpan={2}
                >
                  Taxa
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold' }}
                  align="center"
                  rowSpan={1}
                  colSpan={3}
                >
                  Projeção
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;{header.mesReferencia}&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;{header.mesPrincipal}&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;{header.mesReferencia}&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;{header.mesPrincipal}&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;Antecipação&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;Receita Rede&nbsp;
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  &nbsp;Receita Capittale&nbsp;
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            <TableRow>
          </TableRow>
              {bodyTableProjecao}
              <TableRow>
          </TableRow>
              {bodyTableProjecaoTotal}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}

export default TableContent;
